import { isNumber } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { Rect, Text } from 'react-konva'

export const TextTransformer = ({
  source,
  width,
  height,
  opacity,
  extSourceSize,
  scale,
  setKonvaRefElems,
  assetId,
}) => {
  const textRef = useRef()
  const rectRef = useRef()

  const [ textWidth, setTextWidth ] = useState(null)

  useEffect(() => {
    setTextWidth(prev => {
      if (isNumber(extSourceSize?.width)) {
        return Math.round(extSourceSize.width / scale.x)
      }
      return prev
    })
    setKonvaRefElems(assetId, [ textRef.current ])
    return () => {
      setKonvaRefElems(assetId, [])
    }
  }, [ extSourceSize, scale, assetId, setKonvaRefElems ])
  const { height: textHeight } = textRef.current?.getClientRect() ?? {}

  useEffect(() => () => {
    Array.from(source.children).forEach(node => {
      node.destroy()
    })
  }, [ source.children ])

  return (
    <>
      {Array.from(source.children).map(node => {
        switch (true) {
          case node.className === 'Rect' && node.attrs.key === 'background': {
            return (
              <Rect
                {...node.attrs}
                listnerCount={1} // Ограничение количества слушателей
                batchUpdate
                width={width}
                height={height}
                opacity={opacity}
                ref={rectRef}
              />
            )
          }
          case node.className === 'Rect' && node.attrs.key === 'rect': {
            return (
              <Rect
                {...node.attrs}
                listnerCount={1} // Ограничение количества слушателей
                batchUpdate
                y={height}
                width={Math.floor((textWidth ?? node.attrs.width) * scale.x)}
                height={textHeight * 0.05}
                opacity={opacity}
                ref={rectRef}
              />
            )
          }
          case node.className === 'Text' && node.attrs.key === 'clone': {
            return (
              <Text
                {...node.attrs}
                listnerCount={1} // Ограничение количества слушателей
                batchUpdate
                width={Math.round((textWidth ?? node.attrs.width) * scale.x)}
                fontSize={Math.round(node.attrs.fontSize * scale.y)}
              />
            )
          }
          case node.className === 'Text' && node.attrs.key === 'text': {
            return (
              <Text
                {...node.attrs}
                listnerCount={1} // Ограничение количества слушателей
                batchUpdate
                width={Math.round((textWidth ?? node.attrs.width) * scale.x)}
                fontSize={Math.round(node.attrs.fontSize * scale.y)}
                ref={textRef}
              />
            )
          }
          default: {
            return null
          }
        }
      })}
    </>
  )
}
